import { connect } from 'react-redux';
import VouchersWrapper from "../components/general/VouchersWrapper";
import { REMOVE_VOUCHER, GET_VOUCHERS } from "../store/actions/voucher";

const mapStateToProps = state => {
    return {
        vouchers: state.voucherR,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GET_VOUCHERS: body => dispatch(GET_VOUCHERS(body)),
        REMOVE_VOUCHER: body => dispatch(REMOVE_VOUCHER(body)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(VouchersWrapper);


// WEBPACK FOOTER //
// ./src/containers/Vouchers.js